import { useEventCheckInModal } from '@hooks/useEventCheckInModal';
import React from 'react';
import { EventCheckInModal } from './EventCheckInModal';

export function EventCheckInModalTrigger() {
  const { modalVisible, hideModal, activeEventId, userTicket } =
    useEventCheckInModal();

  if (!modalVisible || !activeEventId || !userTicket) {
    return null;
  }

  return (
    <EventCheckInModal
      visible={modalVisible}
      hide={hideModal}
      eventId={activeEventId}
      ticketToken={userTicket?.token}
    />
  );
}
